import React from 'react';
import { pick, prop } from 'ramda';

import { WebContent } from '@core/js/components/system/WebContent';

import { Menu as MenuCore } from '@theme/js/components/main/Menu/Menu';

import { componentService } from '@core/js/services/component.service';
import { useAppSelector, usePageSelector } from '@core/js/store/hooks';

export const Menu = () => {
    const { menuWcId, overrideMenu } = usePageSelector(pick(['menuWcId', 'overrideMenu']));
    const menuWCID = useAppSelector(prop('menuWCID'));

    if (overrideMenu && menuWcId) {
        return <WebContent id={menuWcId}/>;
    }

    if (menuWCID) {
        return <WebContent id={menuWCID}/>;
    }

    return <MenuCore />;
};

componentService.registerWebContentComponents({ Menu });
